"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=7404%3A1040))
 * @trackcomponent
 * @lastsynced 2025-03-05T22:13:35.550Z
 */
export const Communication = createSVGIcon(
  <>
    <g clipPath="url(#clip0_7404_1040)">
      <path
        d="M15.8164 8.60669C17.7251 8.60669 19.5556 9.36491 20.9052 10.7145C22.2548 12.0642 23.0131 13.8947 23.0131 15.8033C23.0176 17.22 22.5989 18.6056 21.8108 19.7827L23.0131 23L18.966 22.2719C17.9927 22.7465 16.9249 22.9954 15.842 23C14.7592 23.0046 13.6893 22.7646 12.712 22.2983C11.7347 21.8319 10.8753 21.1509 10.1978 20.3063C9.52024 19.4616 9.04205 18.4749 8.79885 17.4196C8.55565 16.3645 8.55369 15.268 8.79314 14.212C9.0326 13.1559 9.50727 12.1675 10.1818 11.3204C10.8563 10.4733 11.7133 9.78936 12.6889 9.3195C13.6645 8.84963 14.7336 8.60598 15.8164 8.60669Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8496 4.39043C15.7093 2.93937 14.1449 1.87999 12.3742 1.35978C10.6035 0.839581 8.71461 0.884451 6.97062 1.48814C5.22662 2.09184 3.71427 3.2243 2.64411 4.72788C1.57395 6.23144 0.999257 8.0313 1.00004 9.87682C0.994792 11.6311 1.51368 13.347 2.49017 14.8044L1.00004 18.7667L4.58989 18.1233"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7404_1040">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>,
  "Communication",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
